import { useState, useEffect } from "react";
import axios from "axios";
import { BaseURL } from "../../App";
import Cookies from "js-cookie";

const Global = ({ onSearch }) => {
  const [question, setQuestion] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [searchResult, setSearchResult] = useState("");
  const [showResult, setShowResult] = useState(false);
  const [ipAddress, setIpAddress] = useState("");

  useEffect(() => {
    // Get the user's IP address when component mounts
    const fetchIpAddress = async () => {
      try {
        const response = await axios.get("https://api.ipify.org?format=json");
        setIpAddress(response.data.ip);
      } catch (error) {
        console.error("Error fetching IP address:", error);
      }
    };

    fetchIpAddress();

    // Check if there's a search query in the URL that might be for global search
    const queryParams = new URLSearchParams(window.location.search);
    const search = queryParams.get("search");
    const type = queryParams.get("type");

    if (search && type === "global") {
      setQuestion(search);
      handleGlobalSearch(search);
    }
  }, []);

  const handleGlobalSearch = async (searchQuery = question) => {
    if (!searchQuery.trim()) return;

    setIsLoading(true);
    setShowResult(true); // Show the loading state in the result area
    setSearchResult(""); // Clear previous results while loading

    const myToken = Cookies.get("access");
    console.log("My Token", myToken);

    try {
      const response = await axios.post(
        BaseURL + "/api/ai_global_search/",
        {
          message: searchQuery,
          ip: ipAddress,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: myToken,
          },
        }
      );

      let message = response.data.message;

      // Remove unnecessary quotes if present
      if (
        message.charAt(0) === "'" &&
        message.charAt(message.length - 1) === "'"
      ) {
        message = message.slice(1, -1);
      }

      // Replace ** with <strong> tags
      let formattedMessage = "";
      let inBold = false;
      let i = 0;

      while (i < message.length) {
        if (
          i < message.length - 1 &&
          message.charAt(i) === "*" &&
          message.charAt(i + 1) === "*"
        ) {
          formattedMessage += inBold ? "</strong>" : "<strong>";
          inBold = !inBold;
          i += 2;
        } else {
          formattedMessage += message.charAt(i);
          i++;
        }
      }

      setSearchResult(formattedMessage);
    } catch (error) {
      console.error("Error performing global search:", error);
      // setSearchResult('<span class="text-red-500">An error occurred while searching. Please try again.</span>');
      setSearchResult(
        `<span class="text-red-500">${error?.response?.data?.message}</span>`
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleGlobalSearch();
  };

  return (
    <div className="pt-4 md:pt-6">
      <h2 className="font-bold text-white text-xl text-center mb-5">
        Ask for the information from our expert AI
      </h2>

      <form
        onSubmit={handleSubmit}
        className="relative md:shadow rounded-full block md:flex justify-center max-w-[800px] mx-auto bg-[]"
      >
        <div className="w-[100%] py-3 pl-5 relative flex gap-2 items-center mb-2 md:mb-0 rounded-full md:rounded-e-none border border-[#2d6bd8] md:border-r-0  text-gray-500 px-2">
          <i className="fa-solid opacity-75 fa-magnifying-glass"></i>
          <input
            required
            className="global_question font-semibold outline-none w-full text-white bg-transparent placeholder:text-white"
            placeholder="Ask your question..."
            type="text"
            autoComplete="off"
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            disabled={isLoading}
          />
        </div>

        <div className="flex items-center">
          <div className="w-full md:w-[130px] md:space-x-4 text-white  rounded-s-full md:rounded-s-none md:border-l-0 rounded-e-full md:p-1 cursor-pointer flex justify-center items-center border border-[#2d6bd8]">
            {!isLoading ? (
              <button
                type="submit"
                className=" main_btn border-2 border-[#2d6bd8] duration-300 transition-all"
              >
                <i className="fa-solid text-xl font-bold fa-magnifying-glass"></i>
                <span className="text-sm font-semibold">Search</span>
              </button>
            ) : (
              <button
                className="loading-button flex gap-2 w-full items-center justify-center p-3 px-4 rounded-full bg-[#2d6bd8] text-white border-2 border-[#2d6bd8]"
                disabled
              >
                <i className="fa-solid text-lg font-bold animate-spin fa-spinner"></i>
                <span className="text-sm font-semibold">Searching...</span>
              </button>
            )}
          </div>
        </div>
      </form>

      {showResult && (
        <div className="search-result-container max-w-[1200px] mt-6 mx-auto">
          {isLoading ? (
            <div className="loading-animation flex flex-col items-center justify-center p-10 bg-gray-100 rounded-2xl">
              <div className="animate-bounce bg-[#2d6bd8] p-2 w-10 h-10 ring-1 ring-[#2d6bd8] shadow-lg rounded-full flex items-center justify-center mb-3">
                <i className="fa-solid fa-magnifying-glass text-white"></i>
              </div>
              <p className="text-gray-600 font-medium">
                Searching for results...
              </p>
              <div className="mt-3 h-2 w-48 bg-gray-200 rounded-full overflow-hidden">
                <div className="animate-pulse h-full bg-[#2d6bd8] rounded-full"></div>
              </div>
            </div>
          ) : (
            <div
              className="search-result-text whitespace-pre-wrap p-5 md:p-10 rounded-2xl bg-[#272737] text-white"
              dangerouslySetInnerHTML={{ __html: searchResult }}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default Global;
